import { render, staticRenderFns } from "./BauprojektAusstattung.vue?vue&type=template&id=65e96a9b&"
import script from "./BauprojektAusstattung.vue?vue&type=script&lang=js&"
export * from "./BauprojektAusstattung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports